var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noData"},[_c('Svgs',{attrs:{"color":"#fff","classes":"noDataSvg","name":"iconNoDataicon"}}),_c('div',{staticClass:"noDataTxt"},[_vm._v("暂无数据")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }